__turbopack_context__.v({
  "article": "CEventsCalendar-module__R9usLG__article",
  "articleBack": "CEventsCalendar-module__R9usLG__articleBack",
  "articleBackLink": "CEventsCalendar-module__R9usLG__articleBackLink",
  "articleBody": "CEventsCalendar-module__R9usLG__articleBody",
  "articleDate": "CEventsCalendar-module__R9usLG__articleDate",
  "articleHeader": "CEventsCalendar-module__R9usLG__articleHeader",
  "articleLead": "CEventsCalendar-module__R9usLG__articleLead",
  "articleTitle": "CEventsCalendar-module__R9usLG__articleTitle",
  "body": "CEventsCalendar-module__R9usLG__body",
  "card": "CEventsCalendar-module__R9usLG__card",
  "cardLink": "CEventsCalendar-module__R9usLG__cardLink",
  "date": "CEventsCalendar-module__R9usLG__date",
  "empty": "CEventsCalendar-module__R9usLG__empty",
  "filterControls": "CEventsCalendar-module__R9usLG__filterControls",
  "filterReset": "CEventsCalendar-module__R9usLG__filterReset",
  "filterSelect": "CEventsCalendar-module__R9usLG__filterSelect",
  "filters": "CEventsCalendar-module__R9usLG__filters",
  "filtersLegend": "CEventsCalendar-module__R9usLG__filtersLegend",
  "gallery": "CEventsCalendar-module__R9usLG__gallery",
  "galleryCaption": "CEventsCalendar-module__R9usLG__galleryCaption",
  "galleryImg": "CEventsCalendar-module__R9usLG__galleryImg",
  "galleryItem": "CEventsCalendar-module__R9usLG__galleryItem",
  "list": "CEventsCalendar-module__R9usLG__list",
  "more": "CEventsCalendar-module__R9usLG__more",
  "root": "CEventsCalendar-module__R9usLG__root",
  "short": "CEventsCalendar-module__R9usLG__short",
  "thumb": "CEventsCalendar-module__R9usLG__thumb",
  "thumbWrap": "CEventsCalendar-module__R9usLG__thumbWrap",
  "title": "CEventsCalendar-module__R9usLG__title",
});
